import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, isAnalyticsEnabled } from "@/lib/analytics";

/**
 * Mounts inside <BrowserRouter> and fires a manual GA4 page_view event
 * on every SPA route change (only if analytics consent has been granted).
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const prevRef = useRef(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (prevRef.current === path) return;
    prevRef.current = path;

    if (!isAnalyticsEnabled()) return;

    // Small delay to let route component update document.title
    const id = setTimeout(() => {
      trackPageView(path, typeof document !== "undefined" ? document.title : "");
    }, 50);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
